import React, { useState, useEffect } from "react";
import "../styles/Header.css";

const Header = ({ onContactClick }) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    // Prevent background scrolling when menu is open
    useEffect(() => {
        if (menuOpen) {
            document.body.classList.add("menu-open");
        } else {
            document.body.classList.remove("menu-open");
        }
    }, [menuOpen]);

    const navItems = [
        { label: "Home", href: "/#profile" },
        { label: "Philosophie", href: "/#profile" },
        { label: "Leistungen", href: "/#services" },
        { label: "Spa & Wellness", href: "/#services2" },
        { label: "Galerie", href: "/#galary" },
        { label: "Blog", href: "/blog" },
        { label: "Kontakt", href: "#" },
    ];

    return (
        <header className="header">
            <div className="header__logo">
                <a href="/#profile" onClick={() => setMenuOpen(false)}>
                    <div className="header__logo-image"></div>
                </a>
            </div>
            <button
                className={`header__menu-toggle ${menuOpen ? "active" : ""}`}
                onClick={toggleMenu}
                aria-label="Toggle menu"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="header__menu-icon"
                    aria-hidden="true"
                >
                    <path
                        fill="currentColor"
                        stroke="currentColor"
                        d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M3 6h18M3 12h18M3 18h18"}
                    />
                </svg>
            </button>
            <nav className={`header__navbar ${menuOpen ? "header__navbar--open" : ""}`}>
                <ul className="header__nav-links">
                    {navItems.map(({ label, href }) => (
                        <li key={label} className="header__nav-item">
                            <a
                                href={href}
                                className="header__nav-link"
                                onClick={(e) => {
                                    setMenuOpen(false);
                                    if (label === "Kontakt") {
                                        e.preventDefault(); // prevent default jump
                                        onContactClick();   // open the modal
                                    }
                                }}
                            >
                                {label}
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>
        </header>
    );
};
export default Header;